// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__Dw-wF","buttons":"SendReceipts_buttons__2BINt","email":"SendReceipts_email__1K6US","bookApptTitle":"SendReceipts_bookApptTitle__9oMfl"};